<template>
  <div>
    <NewOrder></NewOrder>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
const NewOrder = defineAsyncComponent(() =>
  import("@/components/orders/NewOrder")
);
export default {
  components: {
    NewOrder,
  },
};
</script>
